// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1tyQn","name":"ConsentHeader_name__2JYli","birthday":"ConsentHeader_birthday__288Gs","skeleton":"ConsentHeader_skeleton__GAqls"};